export default function CWhileLoop() {
  return <h2>C While Loop</h2>;
}
